import { type FC, useState } from "react";
import { type ContentFileDto, ContentType } from "shared";
import { Navigation } from "swiper/modules";
import { Swiper, type SwiperClass, SwiperSlide } from "swiper/react";
import { Button } from "../components/Button";
import "swiper/css";
import "./ContentCarousel.css";

interface ContentCarouselProps {
	files: ContentFileDto[];
	index?: number;
}

const ContentItem: FC<Readonly<{ file: ContentFileDto }>> = ({ file }) => {
	return (
		<>
			{file.type === ContentType.IMAGE && (
				<img src={file.url} alt={file.filename} />
			)}
			{file.type === ContentType.VIDEO && (
				<video muted controls>
					<source src={file.url} type="video/mp4" />
				</video>
			)}
		</>
	);
};

export const ContentCarousel: FC<ContentCarouselProps> = ({
	files,
	index = 0,
}) => {
	const [swiper, setSwiper] = useState<SwiperClass | null>(null);
	const [currentindex, setCurrentIndex] = useState(0);

	return (
		<div className="slider-wrapper">
			<Swiper
				initialSlide={index}
				modules={[Navigation]}
				slidesPerView={1}
				spaceBetween={16}
				onBeforeInit={(swiper: SwiperClass) => setSwiper(swiper)}
				onSlideChange={(swiper: SwiperClass) => {
					setCurrentIndex(swiper.realIndex);
				}}
				loop
			>
				{files.map((file) => (
					<SwiperSlide key={file.id}>
						<ContentItem file={file} />
					</SwiperSlide>
				))}
			</Swiper>

			{files.length > 1 && (
				<div className="slider-wrapper-nav">
					<Button
						// variant='ghost'
						variant="primary"
						icon="arrow_back_ios"
						iconSize={24}
						onClick={() => swiper?.slidePrev()}
					/>

					<span className="slider-counter">
						{currentindex + 1} / {files.length}
					</span>

					<Button
						// TODO make ghost variant when merged
						// variant='ghost'
						variant="primary"
						icon="arrow_forward_ios"
						iconSize={24}
						onClick={() => swiper?.slideNext()}
					/>
				</div>
			)}
		</div>
	);
};
